import { Steps } from 'antd';
import React from 'react';
import { PHASES } from './data';

export default function PhaseBar({ current, language }) {
	return (
		<Steps current={current} className="onboarding-phase-bar">
			{PHASES.map((phase) => (
				<Steps.Step key={phase.title} title={language[phase.title]} />
			))}
		</Steps>
	);
}
